import { useSelector } from 'react-redux';
import { EFacilityType, NonEmptyArray } from '../../../../../../../packages/JsonQuery';
import { useFilterChangeCallback } from 'shared/hooks';
import { selectBathTypeFilter } from 'shared/selectors/advancedFilters';
import { FC, useCallback } from 'react';
import { AdvancedFilterRow, MultiSelectionAdvancedFilter } from 'shared/components/AdvancedFilter';

export const BathTypeContainer: FC = () => {
  const { label, value, options } = useSelector(selectBathTypeFilter);

  const onChange = useFilterChangeCallback();

  const handleBathTypesChange = useCallback(
    (newValue: NonEmptyArray<EFacilityType> | null) => {
      onChange({ action: 'setBathTypes', arguments: [newValue] });
    },
    [onChange],
  );

  return (
    <AdvancedFilterRow label={label}>
      <MultiSelectionAdvancedFilter value={value} options={options} onFilterChange={handleBathTypesChange} />
    </AdvancedFilterRow>
  );
};
